var TorsoView = require('backbone-torso/modules/View');
var eregPatientAppointmentSelectionLayoutTemplate = require('./eregPatientAppointmentsLayoutTemplate.hbs');
var EregPatientAppointmentsListWidget = require('./EregPatientAppointmentsListWidget');
var PatientSummaryView = require('./../../patient-summary/PatientSummaryView');

/**
 * Perspective to display the E-reg patient appointment selection page.
 *
 * @class EregPatientAppointmentSelectionPerspective
 * @constructor
 */
module.exports = TorsoView.extend({
  className: 'page-content brec-main',
  attributes: {
    'data-test-ereg-patient-appointment-selection': true
  },
  tagName: 'main',
  template: eregPatientAppointmentSelectionLayoutTemplate,
  moduleNamespace: 'eregPatientAppointmentSelection',

  /**
   * @method initialize
   * @param options {Object}
   *   @param options.patientVecnaId {String} the vecna id of the patient to display the appointments for.
   * @override
   */
  initialize: function(options) {
    this._patientVecnaId = options.patientVecnaId;
    this._appointmentSelectionListView = new EregPatientAppointmentsListWidget({ patientVecnaId: this._patientVecnaId });
    this._patientSummaryView = new PatientSummaryView({ patientVecnaId: this._patientVecnaId });
    this.set({
      asideHeaderMessageKey: 'ereg.appointments.aside.header',
      asideContentMessageKey: 'ereg.appointments.aside'
    });
    this.set('navView', 'eregPatient');
  },

  /**
   * @method changePatientVecnaId
   * @param patientVecnaId
   */
  changePatientVecnaId: function(patientVecnaId) {
    this._appointmentSelectionListView.changePatientVecnaId(patientVecnaId);
    this._patientSummaryView.changePatientVecnaId(patientVecnaId);
  },

  /**
   * @method attachTrackedViews
   * @override
   */
  attachTrackedViews: function() {
    this.attachView('patient-summary', this._patientSummaryView);
    this.attachView('appointment-list', this._appointmentSelectionListView);
  }
});
